"use client"

import { resultPostprocessing2 } from "@/components/fetcher/fetchInterceptor"
import fetchInterceptorInClient from "@/components/fetcher/fetchInterceptorInClient"

const ROOT = process.env.NEXT_PUBLIC_ROOT

export type KyoboPurchaseSyncStatus = "CONSENTED" | "WITHDRAWN"

// export type KyoboOrderConnectionResponse = {
//   id: number
//   memberId: number
//   kbbMemberNumber: string
//   consented: boolean
//   status: KyoboPurchaseSyncStatus
//   consentedAt: string | null
//   withdrawnAt: string | null
//   createdAt: string
//   updatedAt: string
// }

export type KyoboOrderConnectionResponse = {
  status: KyoboPurchaseSyncStatus
}

const fetchClientPurchaseSyncConsentStatus = () =>
  fetchInterceptorInClient(
    {
      method: "get",
      credentials: "same-origin",
    },
    ROOT,
  )(() => `/api/account/purchase-sync-consent`).then(
    resultPostprocessing2<KyoboOrderConnectionResponse | null>,
  )

export default fetchClientPurchaseSyncConsentStatus
